import React, { useState } from 'react'
import { Grid, Typography, styled } from '@mui/material'
import { Clipboard, DialogPopup } from '../components'
import { translate } from '../i18n'
import {
    PREVIEW_URL,
    PRODUCTION_URL,
    ProjectPreviewPopupProps,
} from './ProjectPreviewPopup.types'

const Image = styled('img')(({ theme }) => ({
    width: '100%',
}))

function ProjectPreviewPopup({
    stage,
    project,
    onClose,
}: ProjectPreviewPopupProps) {
    const [url] = useState(() => {
        if (stage === 'dev') {
            return `${PREVIEW_URL}/${project.id}`
        }
        return `${PRODUCTION_URL}/${project.id}`
    })

    return (
        <DialogPopup
            open
            title={translate(`projects.${stage}.title`) as string}
            maxWidth="xs"
            fullWidth
            onClose={onClose}
            button={{
                text: translate('buttons.open'),
                href: url,
            }}
            leftButton={stage === "prod" && project.qr_url ? ({
                text: translate("buttons.download_qr") as string,
                href: project.qr_url,
            }) : undefined}
        >
            <Typography variant="body2" paragraph>
                {translate(`projects.${stage}.text`, project)}
            </Typography>
            <Grid
                container
                justifyContent="center"
                alignContent="center"
                alignItems="center"
                spacing={2}
                sx={{ mb: 2 }}
            >
                {stage === 'prod' && (
                    <Grid item xs={12} md={10}>
                        <Image src={project.qr_url} alt="qr" />
                    </Grid>
                )}
                <Grid item xs={12}>
                    <Clipboard value={url} />
                </Grid>
            </Grid>
        </DialogPopup>
    )
}

export default ProjectPreviewPopup
